/**
 * Copyright 2022-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __awaiter } from "tslib";
export const LOGGER_NAME = 'OdpEventApiManager';
export class DefaultOdpEventApiManager {
    constructor(requestHandler, requestDataGenerator, logger) {
        this.requestHandler = requestHandler;
        this.requestGenerator = requestDataGenerator;
        if (logger) {
            this.setLogger(logger);
        }
    }
    setLogger(logger) {
        this.logger = logger;
        this.logger.setName(LOGGER_NAME);
    }
    sendEvents(odpConfig, events) {
        return __awaiter(this, void 0, void 0, function* () {
            if (events.length === 0) {
                return {};
            }
            const { method, endpoint, headers, data } = this.requestGenerator(odpConfig, events);
            const request = this.requestHandler.makeRequest(endpoint, headers, method, data);
            return request.responsePromise;
        });
    }
}
export const pixelApiRequestGenerator = (odpConfig, events) => {
    const pixelApiPath = 'v2/zaius.gif';
    const pixelApiEndpoint = new URL(pixelApiPath, odpConfig.pixelUrl);
    const apiKey = odpConfig.apiKey;
    const method = 'GET';
    const event = events[0];
    event.identifiers.forEach((v, k) => {
        pixelApiEndpoint.searchParams.append(k, v);
    });
    event.data.forEach((v, k) => {
        pixelApiEndpoint.searchParams.append(k, v);
    });
    pixelApiEndpoint.searchParams.append('tracker_id', apiKey);
    pixelApiEndpoint.searchParams.append('event_type', event.type);
    pixelApiEndpoint.searchParams.append('vdl_action', event.action);
    const endpoint = pixelApiEndpoint.toString();
    return {
        method,
        endpoint,
        headers: {},
        data: '',
    };
};
export const eventApiRequestGenerator = (odpConfig, events) => {
    const { apiHost, apiKey } = odpConfig;
    return {
        method: 'POST',
        endpoint: `${apiHost}/v3/events`,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey,
        },
        data: JSON.stringify(events, (_, value) => {
            return value instanceof Map ? Object.fromEntries(value) : value;
        }),
    };
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=odp_event_api_manager.js.map